import { render, staticRenderFns } from "./RecordLiaison.vue?vue&type=template&id=dba05650&"
import script from "./RecordLiaison.vue?vue&type=script&lang=js&"
export * from "./RecordLiaison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports